import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";

export const postParseChecksCSV =
  (axios: IAxiosInstance) => async (csv: string, payrollRunID?: string) => {
    const response = await axios.noRetry.post("/api/preview-check-csv", {
      csv,
      payrollRunID,
    });
    const resData = response.data as
      | { success: true; data: unknown }
      | { success: false; errors?: Array<{ code: string; message: string }> };
    if (resData.success) {
      return resData.data;
    }
    const errors = resData.errors ?? [];
    const firstMessage =
      errors[0]?.message ??
      "Error parsing CSV file. Please ensure file matches provided template.";
    const err = new Error(firstMessage) as Error & {
      response: { data: { errors: Array<{ code: string; message: string }> } };
    };
    err.response = { data: { errors } };
    throw err;
  };
